import { getPatInfo } from "./util-table";
import { string2Num } from "./utils";

export const sortByLift = (a, b) => {
  const getCode = (t) => {
    let code = 0;
    if (t.includes("g") && t.includes("i")) {
      code += 10;
    }

    if (t.includes("g")) {
      code += 2;
    }
    if (t.includes("i")) {
      code += 1;
    }
    if (t.includes("r")) {
      code += 1;
    }
    if (t.includes("B")) {
      code += 1;
    }
    if (t.includes("!!")) {
      code += 5;
    } else if (t.includes("!")) {
      code += 2;
    }
    code += t.length >= 3 ? 1 : 0;
    return code;
  };
  return getCode(a) - getCode(b);
};

export const sortAttr = (a, b) => {
  return a.length - b.length;
};
export const sortByLScore = (a, b) => {
  if (!a) {
    return -1;
  }
  if (!b) {
    return 1;
  }
  const getCode = (str) => {
    let code = 0;
    if (!str) {
      return code;
    }
    if (str.includes("D3") || str.includes("D4")) {
      code += 60;
    } else if (str.includes("n")) {
      code += 40;
    } else if (str.includes("C")) {
      code += 30;
    } else if (str.includes("G")) {
      code += 20;
    }
    //code += parseInt(str) //Nan
    return code;
  };
  //console.log(a, b, getCode(a),getCode(b))
  return getCode(a) - getCode(b);
};

export const sortByLength = (a, b) => {
  if (!a) {
    return -1;
  }
  if (!b) {
    return 1;
  }
  return a.length - b.length;
};

export const sortPatternFn = (a, b) => {
  const aCode = a ? a.length : 0;
  const bCode = b ? b.length : 0;

  if (aCode === bCode && aCode > 0) {
    return b > a ? "1" : "-1";
  }
  return aCode - bCode;
};
//12Nh+u11.8
export const sortByHScore = (a, b) => {
  if (!a) {
    return -1;
  }
  if (!b) {
    return 1;
  }
  return parseInt(a) - parseInt(b);
};

export const sortByBScore = (a, b) => {
  if (!a) {
    return -1;
  }
  if (!b) {
    return 1;
  }
  const getCode = (str) => {
    let code = 0;
    if (str.includes("**")) {
      code += 100;
    } else if (str.includes("*")) {
      code += 20;
    }

    let duration = parseInt(str.split(" ")[0].replace(/\D/g, ""));
    if (duration > 0) {
      code += duration;
    }

    return code;
  };
  return getCode(a) - getCode(b);
};

export const sortByNumber = (a, b) => Number(b) - Number(a);

export const sortByER = (a, b) => {
  if (!a) {
    return -1;
  }
  if (!b) {
    return 1;
  }
  const getCode = (t) => {
    let code = parseInt(t);
    if (t.includes("A")) {
      code += 0.4;
    } else if (t.includes("B")) {
      code -= 0.4;
    }
    return Math.abs(code);
  };
  return getCode(b) - getCode(a);
};

export const SectorDividers = [
  "bank",
  "consumer",
  "trans",
  "material",
  "defence",
  "asian",
];
export const SectorsList = [
  "etf",
  "bond",
  "fang",
  "semi",
  "security",
  "enterprise",
  "social",
  "nuclear",
  "quantum",

  "old-tech",
  "small",
  "av",
  "fintech",
  "payroll",
  "cc",
  "bit",
  "bank",
  "home",
  "builder",
  "credit",
  "gig",
  "consumer",
  "trans",
  "travel",
  "jets",
  "chain",
  "material",
  "precious",
  "lit",
  "energy",
  "solar",
  "defence",
  "bio",
  "covid",
  "nutri",
  "asian",
  "china",
  "ai",
  "new-ipo",
  "cannabis",
  "short",
  "undefined",
];

export const sortPureSector = (a, b) => {
  return SectorsList.indexOf(a) - SectorsList.indexOf(b);
};

export const sortSector = (a, b) => {
  const getCode = (sector) => {
    const MAX_SYMBOL_NUMBER = 30;
    let sectorIndex = SectorsList.indexOf(sector.replace(/[0-9]/g, ""));
    const symbolIndex = string2Num(sector) || 0;
    return sectorIndex * MAX_SYMBOL_NUMBER + Number(symbolIndex);
  };
  return getCode(b) - getCode(a);
};

export const sortSectorObj = (a, b) => {
  const getCode = (sector) => {
    if (!sector) {
      return 0;
    }
    const MAX_SYMBOL_NUMBER = 30;
    let sectorIndex = SectorsList.indexOf(sector.replace(/[0-9]/g, ""));
    const symbolIndex = string2Num(sector) || 0;
    return sectorIndex * MAX_SYMBOL_NUMBER + Number(symbolIndex);
  };

  //console.log('CCCC', SectorsList.indexOf(a.sector.replace(/[0-9]/g, "")), string2Num(a.sector), string2Num(b.sector) )
  return getCode(a.sector.toLowerCase()) - getCode(b.sector.toLowerCase());
};

export const sortGroupSignalSectorObj = (a, b) => {
  const getSectorIndex = (sector) => {
    if (!sector) {
      return 0;
    }

    let sectorIndex = SectorsList.indexOf(sector.replace(/[0-9]/g, ""));

    return sectorIndex;
  };

  if (a.order_type !== b.order_type) {
    return Number(b.order_type) - Number(a.order_type);
  }
  //console.log('CCCC', SectorsList.indexOf(a.sector.replace(/[0-9]/g, "")), string2Num(a.sector), string2Num(b.sector) )
  return (
    getSectorIndex(a.sector.toLowerCase()) -
    getSectorIndex(b.sector.toLowerCase())
  );
};

export const sortDateSymbol = (a, b) => {
  const getCode = (sector) => {
    if (!sector) {
      return 0;
    }
    const MAX_SYMBOL_NUMBER = 30;
    let sectorIndex = SectorsList.indexOf(sector.replace(/[0-9]/g, ""));
    const symbolIndex = string2Num(sector) || 0;
    return sectorIndex * MAX_SYMBOL_NUMBER + Number(symbolIndex);
  };
  if (a.date === b.date) {
    return getCode(a.sector) - getCode(b.sector);
  }
  return new Date(b.date) - new Date(a.date);
};

export const sortSectorObjGrouped = (a, b) => {
  const getCode = (sector) => {
    if (!sector) {
      return 0;
    }
    const MAX_SYMBOL_NUMBER = 30;
    let sectorIndex = SectorsList.indexOf(sector.replace(/[0-9]/g, ""));
    const symbolIndex = string2Num(sector) || 0;
    return sectorIndex * MAX_SYMBOL_NUMBER + Number(symbolIndex);
  };

  const patCompare = b.commonPattern.length - a.commonPattern.length;
  const lengthCompare = b.group.length - a.group.length;
  const sectorCompare = getCode(a.group[0].sector) - getCode(b.group[0].sector);

  if (b.commonPattern.length >= 7 && a.commonPattern.length >= 7) {
    if (sectorCompare === 0) {
      return patCompare;
    }
    return sectorCompare;
  } else {
    return patCompare;
  }

  //return lengthCompare;
};

export const sortStrength = (a, b) => {
  let numA = a.replace(/\D/g, "");
  let numB = b.replace(/\D/g, "");
  numA = numA ? parseInt(numA) : -Infinity;
  numB = numB ? parseInt(numB) : -Infinity;
  return numA - numB;
};

export const sortPatSize = (ticks) => (valA, valB) => {
  const { patSize: patSizeA } = getPatInfo(ticks, valA);
  const { patSize: patSizeB } = getPatInfo(ticks, valB);
  return patSizeB - patSizeA;
};

//const string2Num = (str) => Number(str.replace(/[a-zA-Z]/g, "")) || 0;
export const sortByStringNum = (a, b) => string2Num(a) - string2Num(b);
export const sortByAbs = (a, b) =>
  Math.abs(string2Num(a)) - Math.abs(string2Num(b));
export const sortDescend = (a, b) => Number(b) - Number(a);

export const filterFunc = (formatted) => (t) => {
  return formatted && formatted.includes(t);
};
